import styled from "@emotion/styled";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { fontRoboto, ShareButton } from "@product/scmp-sdk";

import IconEmail from "./icon-email.svg";
import IconFacebook from "./icon-facebook.svg";
import IconTelegram from "./icon-telegram.svg";
import IconTwitter from "./icon-twitter.svg";
import IconWhatsapp from "./icon-whatsapp.svg";

export const StyledIconEmail = styled(IconEmail)``;
export const StyledIconFacebook = styled(IconFacebook)``;
export const StyledIconTelegram = styled(IconTelegram)``;
export const StyledIconTwitter = styled(IconTwitter)``;
export const StyledIconWhatsapp = styled(IconWhatsapp)``;

export const StyledPaper = styled(Paper)`
  inline-size: 200px;
  margin-block: 8px;
  padding-block: 20px;

  border: 1px solid #000000;
  border-radius: 4px;

  background-color: #ffffff;
`;

export const StyledMenuItem = styled(MenuItem)`
  padding-block: 8px;
  padding-inline: 20px;

  :hover {
    background-color: #ffffff;
  }
`;

export const Header = styled.div`
  padding-block: 4px;
  padding-inline: 20px;

  color: #000000;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
`;

export const StyledShareButton = styled(ShareButton)`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;

  :hover {
    text-decoration: underline;
  }

  ${StyledIconEmail},
  ${StyledIconFacebook},
  ${StyledIconTelegram},
  ${StyledIconTwitter},
  ${StyledIconWhatsapp} {
    path:last-child {
      fill: #000000;
    }
  }

  > span {
    flex: 1 1 auto;

    padding: 0;

    text-align: start;
  }
`;
